export const InfoAlert = ({ children }) => {
  return (
    <div className="alert">
      <span className="alert-icon">💡</span>
      <p className="m-0 fs-10">
        <strong className="font-semibold">Quick Start:</strong> {children}
      </p>
    </div>
  );
};

// 📥
// 📤
export const maritalStatusData = [
  {
    value: "L",
    title: "Legally Separated",
  },
  {
    value: "D",
    title: "Divorced",
  },
  {
    value: "M",
    title: "Married",
  },
  {
    value: "U",
    title: "unmarried",
  },
  {
    value: "W",
    title: "Widowed",
  },
];

export const genderData = [
  { value: "male", title: "Male" },
  { value: "female", title: "Female" },
  { value: "unknown", title: "Unknown" },
  { value: "U", title: "Undetermined" },
  { value: "N", title: "Undifferentiated" },
  { value: "A", title: "Sex changed to Male" },
  { value: "B", title: "Sex changed to Female" },
  { value: "C", title: "Not Completed" },
];

export const nationalityData = [
  {
    value: "ABW",
    title: "Aruba",
  },
  {
    value: "AFG",
    title: "Afghanistan",
  },
  {
    value: "AGO",
    title: "Angola",
  },
  {
    value: "AIA",
    title: "Anguilla",
  },
  {
    value: "ALA",
    title: "Eland Islands",
  },
  {
    value: "ALB",
    title: "Albania",
  },
  {
    value: "AND",
    title: "Andorra",
  },
  {
    value: "ARE",
    title: "United Arab Emirates",
  },
  {
    value: "ARG",
    title: "Argentina",
  },
  {
    value: "ARM",
    title: "Armenia",
  },
  {
    value: "ASM",
    title: "American Samoa",
  },
  {
    value: "ATA",
    title: "Antarctica",
  },
  {
    value: "ATF",
    title: "French Southern Territories",
  },
  {
    value: "ATG",
    title: "Antigua and Barbuda",
  },
  {
    value: "AUS",
    title: "Australia",
  },
  {
    value: "AUT",
    title: "Austria",
  },
  {
    value: "AZE",
    title: "Azerbaijan",
  },
  {
    value: "BDI",
    title: "Burundi",
  },
  {
    value: "BEL",
    title: "Belgium",
  },
  {
    value: "BEN",
    title: "Benin",
  },
  {
    value: "BES",
    title: "Bonaire, Sint Eustatius and Saba",
  },
  {
    value: "BFA",
    title: "Burkina Faso",
  },
  {
    value: "BGD",
    title: "Bangladesh",
  },
  {
    value: "BGR",
    title: "Bulgaria",
  },
  {
    value: "BHR",
    title: "Bahrain",
  },
  {
    value: "BHS",
    title: "Bahamas",
  },
  {
    value: "BIH",
    title: "Bosnia and Herzegovina",
  },
  {
    value: "BLM",
    title: "Saint Barthilemy",
  },
  {
    value: "BLR",
    title: "Belarus",
  },
  {
    value: "BLZ",
    title: "Belize",
  },
  {
    value: "BMU",
    title: "Bermuda",
  },
  {
    value: "BOL",
    title: "Bolivia, Plurinational State of",
  },
  {
    value: "BRA",
    title: "Brazil",
  },
  {
    value: "BRB",
    title: "Barbados",
  },
  {
    value: "BRN",
    title: "Brunei Darussalam",
  },
  {
    value: "BTN",
    title: "Bhutan",
  },
  {
    value: "BVT",
    title: "Bouvet Island",
  },
  {
    value: "BWA",
    title: "Botswana",
  },
  {
    value: "CAF",
    title: "Central African Republic",
  },
  {
    value: "CAN",
    title: "Canada",
  },
  {
    value: "CCK",
    title: "Cocos (Keeling) Islands",
  },
  {
    value: "CHE",
    title: "Switzerland",
  },
  {
    value: "CHL",
    title: "Chile",
  },
  {
    value: "CHN",
    title: "China",
  },
  {
    value: "CIV",
    title: "Ctte d Ivoire",
  },
  {
    value: "CMR",
    title: "Cameroon",
  },
  {
    value: "COD",
    title: "Congo, the Democratic Republic of the",
  },
  {
    value: "COG",
    title: "Congo",
  },
  {
    value: "COK",
    title: "Cook Islands",
  },
  {
    value: "COL",
    title: "Colombia",
  },
  {
    value: "COM",
    title: "Comoros",
  },
  {
    value: "CPV",
    title: "Cabo Verde",
  },
  {
    value: "CRI",
    title: "Costa Rica",
  },
  {
    value: "CUB",
    title: "Cuba",
  },
  {
    value: "CUW",
    title: "Curagao",
  },
  {
    value: "CXR",
    title: "Christmas Island",
  },
  {
    value: "CYM",
    title: "Cayman Islands",
  },
  {
    value: "CYP",
    title: "Cyprus",
  },
  {
    value: "CZE",
    title: "Czechia",
  },
  {
    value: "DEU",
    title: "Germany",
  },
  {
    value: "DJI",
    title: "Djibouti",
  },
  {
    value: "DMA",
    title: "Dominica",
  },
  {
    value: "DNK",
    title: "Denmark",
  },
  {
    value: "DOM",
    title: "Dominican Republic",
  },
  {
    value: "DZA",
    title: "Algeria",
  },
  {
    value: "ECU",
    title: "Ecuador",
  },
  {
    value: "EGY",
    title: "Egypt",
  },
  {
    value: "ERI",
    title: "Eritrea",
  },
  {
    value: "ESH",
    title: "Western Sahara",
  },
  {
    value: "ESP",
    title: "Spain",
  },
  {
    value: "EST",
    title: "Estonia",
  },
  {
    value: "ETH",
    title: "Ethiopia",
  },
  {
    value: "FIN",
    title: "Finland",
  },
  {
    value: "FJI",
    title: "Fiji",
  },
  {
    value: "FLK",
    title: "Falkland Islands (Malvinas)",
  },
  {
    value: "FRA",
    title: "France",
  },
  {
    value: "FRO",
    title: "Faroe Islands",
  },
  {
    value: "FSM",
    title: "Micronesia, Federated States of",
  },
  {
    value: "GAB",
    title: "Gabon",
  },
  {
    value: "GBR",
    title: "United Kingdom",
  },
  {
    value: "GEO",
    title: "Georgia",
  },
  {
    value: "GGY",
    title: "Guernsey",
  },
  {
    value: "GHA",
    title: "Ghana",
  },
  {
    value: "GIB",
    title: "Gibraltar",
  },
  {
    value: "GIN",
    title: "Guinea",
  },
  {
    value: "GLP",
    title: "Guadeloupe",
  },
  {
    value: "GMB",
    title: "Gambia",
  },
  {
    value: "GNB",
    title: "Guinea-Bissau",
  },
  {
    value: "GNQ",
    title: "Equatorial Guinea",
  },
  {
    value: "GRC",
    title: "Greece",
  },
  {
    value: "GRD",
    title: "Grenada",
  },
  {
    value: "GRL",
    title: "Greenland",
  },
  {
    value: "GTM",
    title: "Guatemala",
  },
  {
    value: "GUF",
    title: "French Guiana",
  },
  {
    value: "GUM",
    title: "Guam",
  },
  {
    value: "GUY",
    title: "Guyana",
  },
  {
    value: "HKG",
    title: "Hong Kong",
  },
  {
    value: "HMD",
    title: "Heard Island and McDonald Islands",
  },
  {
    value: "HND",
    title: "Honduras",
  },
  {
    value: "HRV",
    title: "Croatia",
  },
  {
    value: "HTI",
    title: "Haiti",
  },
  {
    value: "HUN",
    title: "Hungary",
  },
  {
    value: "IDN",
    title: "Indonesia",
  },
  {
    value: "IMN",
    title: "Isle of Man",
  },
  {
    value: "IND",
    title: "India",
  },
  {
    value: "IOT",
    title: "British Indian Ocean Territory",
  },
  {
    value: "IRL",
    title: "Ireland",
  },
  {
    value: "IRN",
    title: "Iran, Islamic Republic of",
  },
  {
    value: "IRQ",
    title: "Iraq",
  },
  {
    value: "ISL",
    title: "Iceland",
  },
  {
    value: "ISR",
    title: "Israel",
  },
  {
    value: "ITA",
    title: "Italy",
  },
  {
    value: "JAM",
    title: "Jamaica",
  },
  {
    value: "JEY",
    title: "Jersey",
  },
  {
    value: "JOR",
    title: "Jordan",
  },
  {
    value: "JPN",
    title: "Japan",
  },
  {
    value: "KAZ",
    title: "Kazakhstan",
  },
  {
    value: "KEN",
    title: "Kenya",
  },
  {
    value: "KGZ",
    title: "Kyrgyzstan",
  },
  {
    value: "KHM",
    title: "Cambodia",
  },
  {
    value: "KIR",
    title: "Kiribati",
  },
  {
    value: "KNA",
    title: "Saint Kitts and Nevis",
  },
  {
    value: "KOR",
    title: "Korea, Republic of",
  },
  {
    value: "KWT",
    title: "Kuwait",
  },
  {
    value: "LAO",
    title: "Lao Peoples Democratic Republic",
  },
  {
    value: "LBN",
    title: "Lebanon",
  },
  {
    value: "LBR",
    title: "Liberia",
  },
  {
    value: "LBY",
    title: "Libya",
  },
  {
    value: "LCA",
    title: "Saint Lucia",
  },
  {
    value: "LIE",
    title: "Liechtenstein",
  },
  {
    value: "LKA",
    title: "Sri Lanka",
  },
  {
    value: "LSO",
    title: "Lesotho",
  },
  {
    value: "LTU",
    title: "Lithuania",
  },
  {
    value: "LUX",
    title: "Luxembourg",
  },
  {
    value: "LVA",
    title: "Latvia",
  },
  {
    value: "MAC",
    title: "Macao",
  },
  {
    value: "MAF",
    title: "Saint Martin (French part)",
  },
  {
    value: "MAR",
    title: "Morocco",
  },
  {
    value: "MCO",
    title: "Monaco",
  },
  {
    value: "MDA",
    title: "Moldova, Republic of",
  },
  {
    value: "MDG",
    title: "Madagascar",
  },
  {
    value: "MDV",
    title: "Maldives",
  },
  {
    value: "MEX",
    title: "Mexico",
  },
  {
    value: "MHL",
    title: "Marshall Islands",
  },
  {
    value: "MKD",
    title: "Macedonia, the former Yugoslav Republic of",
  },
  {
    value: "MLI",
    title: "Mali",
  },
  {
    value: "MLT",
    title: "Malta",
  },
  {
    value: "MMR",
    title: "Myanmar",
  },
  {
    value: "MNE",
    title: "Montenegro",
  },
  {
    value: "MNG",
    title: "Mongolia",
  },
  {
    value: "MNP",
    title: "Northern Mariana Islands",
  },
  {
    value: "MOZ",
    title: "Mozambique",
  },
  {
    value: "MRT",
    title: "Mauritania",
  },
  {
    value: "MSR",
    title: "Montserrat",
  },
  {
    value: "MTQ",
    title: "Martinique",
  },
  {
    value: "MUS",
    title: "Mauritius",
  },
  {
    value: "MWI",
    title: "Malawi",
  },
  {
    value: "MYS",
    title: "Malaysia",
  },
  {
    value: "MYT",
    title: "Mayotte",
  },
  {
    value: "NAM",
    title: "Namibia",
  },
  {
    value: "NCL",
    title: "New Caledonia",
  },
  {
    value: "NER",
    title: "Niger",
  },
  {
    value: "NFK",
    title: "Norfolk Island",
  },
  {
    value: "NGA",
    title: "Nigeria",
  },
  {
    value: "NIC",
    title: "Nicaragua",
  },
  {
    value: "NIU",
    title: "Niue",
  },
  {
    value: "NLD",
    title: "Netherlands",
  },
  {
    value: "NOR",
    title: "Norway",
  },
  {
    value: "NPL",
    title: "Nepal",
  },
  {
    value: "NRU",
    title: "Nauru",
  },
  {
    value: "NZL",
    title: "New Zealand",
  },
  {
    value: "OMN",
    title: "Oman",
  },
  {
    value: "PAK",
    title: "Pakistan",
  },
  {
    value: "PAN",
    title: "Panama",
  },
  {
    value: "PCN",
    title: "Pitcairn",
  },
  {
    value: "PER",
    title: "Peru",
  },
  {
    value: "PHL",
    title: "Philippines",
  },
  {
    value: "PLW",
    title: "Palau",
  },
  {
    value: "PNG",
    title: "Papua New Guinea",
  },
  {
    value: "POL",
    title: "Poland",
  },
  {
    value: "PRI",
    title: "Puerto Rico",
  },
  {
    value: "PRK",
    title: "Korea, Democratic Peoples Republic of",
  },
  {
    value: "PRT",
    title: "Portugal",
  },
  {
    value: "PRY",
    title: "Paraguay",
  },
  {
    value: "PSE",
    title: "Palestine, State of",
  },
  {
    value: "PYF",
    title: "French Polynesia",
  },
  {
    value: "QAT",
    title: "Qatar",
  },
  {
    value: "REU",
    title: "Riunion",
  },
  {
    value: "ROU",
    title: "Romania",
  },
  {
    value: "RUS",
    title: "Russian Federation",
  },
  {
    value: "RWA",
    title: "Rwanda",
  },
  {
    value: "SAU",
    title: "Saudi Arabia",
  },
  {
    value: "SDN",
    title: "Sudan",
  },
  {
    value: "SEN",
    title: "Senegal",
  },
  {
    value: "SGP",
    title: "Singapore",
  },
  {
    value: "SGS",
    title: "South Georgia and the South Sandwich Islands",
  },
  {
    value: "SHN",
    title: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    value: "SJM",
    title: "Svalbard and Jan Mayen",
  },
  {
    value: "SLB",
    title: "Solomon Islands",
  },
  {
    value: "SLE",
    title: "Sierra Leone",
  },
  {
    value: "SLV",
    title: "El Salvador",
  },
  {
    value: "SMR",
    title: "San Marino",
  },
  {
    value: "SOM",
    title: "Somalia",
  },
  {
    value: "SPM",
    title: "Saint Pierre and Miquelon",
  },
  {
    value: "SRB",
    title: "Serbia",
  },
  {
    value: "SSD",
    title: "South Sudan",
  },
  {
    value: "STP",
    title: "Sao Tome and Principe",
  },
  {
    value: "SUR",
    title: "Suriname",
  },
  {
    value: "SVK",
    title: "Slovakia",
  },
  {
    value: "SVN",
    title: "Slovenia",
  },
  {
    value: "SWE",
    title: "Sweden",
  },
  {
    value: "SWZ",
    title: "Swaziland",
  },
  {
    value: "SXM",
    title: "Sint Maarten (Dutch part)",
  },
  {
    value: "SYC",
    title: "Seychelles",
  },
  {
    value: "SYR",
    title: "Syrian Arab Republic",
  },
  {
    value: "TCA",
    title: "Turks and Caicos Islands",
  },
  {
    value: "TCD",
    title: "Chad",
  },
  {
    value: "TGO",
    title: "Togo",
  },
  {
    value: "THA",
    title: "Thailand",
  },
  {
    value: "TJK",
    title: "Tajikistan",
  },
  {
    value: "TKL",
    title: "Tokelau",
  },
  {
    value: "TKM",
    title: "Turkmenistan",
  },
  {
    value: "TLS",
    title: "Timor-Leste",
  },
  {
    value: "TON",
    title: "Tonga",
  },
  {
    value: "TTO",
    title: "Trinidad and Tobago",
  },
  {
    value: "TUN",
    title: "Tunisia",
  },
  {
    value: "TUR",
    title: "Turkey",
  },
  {
    value: "TUV",
    title: "Tuvalu",
  },
  {
    value: "TWN",
    title: "Taiwan, Province of China",
  },
  {
    value: "TZA",
    title: "Tanzania, United Republic of",
  },
  {
    value: "UGA",
    title: "Uganda",
  },
  {
    value: "UKR",
    title: "Ukraine",
  },
  {
    value: "UMI",
    title: "United States Minor Outlying Islands",
  },
  {
    value: "URY",
    title: "Uruguay",
  },
  {
    value: "USA",
    title: "United States of America",
  },
  {
    value: "UZB",
    title: "Uzbekistan",
  },
  {
    value: "VAT",
    title: "Holy See",
  },
  {
    value: "VCT",
    title: "Saint Vincent and the Grenadines",
  },
  {
    value: "VEN",
    title: "Venezuela, Bolivarian Republic of",
  },
  {
    value: "VGB",
    title: "Virgin Islands, British",
  },
  {
    value: "VIR",
    title: "Virgin Islands, U.S.",
  },
  {
    value: "VNM",
    title: "Viet Nam",
  },
  {
    value: "VUT",
    title: "Vanuatu",
  },
  {
    value: "WLF",
    title: "Wallis and Futuna",
  },
  {
    value: "WSM",
    title: "Samoa",
  },
  {
    value: "YEM",
    title: "Yemen",
  },
  {
    value: "ZAF",
    title: "South Africa",
  },
  {
    value: "ZMB",
    title: "Zambia",
  },
  {
    value: "ZWE",
    title: "Zimbabwe",
  },
];

export const specilaityData = [
  {
    value: "01.00",
    title: "Anesthesiology Specialty",
  },
  {
    value: "01.01",
    title: "Ambulatory Anesthesia",
  },
  {
    value: "01.02",
    title: "Anesthesia Cardiology",
  },
  {
    value: "01.03",
    title: "Neuro-Anesthesia",
  },
  {
    value: "01.04",
    title: "Obstetrics Anesthesia ",
  },
  {
    value: "01.05",
    title: "Pediatrics Anesthesia",
  },
  {
    value: "01.06",
    title: "Pediatrics Cardiac Anesthesia ",
  },
  {
    value: "01.07",
    title: "Regional Anesthesia",
  },
  {
    value: "01.08",
    title: "Vascular / Thoracic Anesthesia",
  },
  {
    value: "02.00",
    title: "Community Medicine Specialty",
  },
  {
    value: "02.01",
    title: "Community Health",
  },
  {
    value: "03.00",
    title: "Dermatology Specialty",
  },
  {
    value: "03.01",
    title: "Dermatology Surgery ",
  },
  {
    value: "03.02",
    title: "Hair Implant Dermatology ",
  },
  {
    value: "03.03",
    title: "Pediatrics Dermatology ",
  },
  {
    value: "04.00",
    title: "Emergency Medicine Specialty ",
  },
  {
    value: "04.01",
    title: "Adult Emergency Medicine ",
  },
  {
    value: "04.02",
    title: "Pediatrics Emergency Medicine ",
  },
  {
    value: "05.00",
    title: "Ear, Nose & Throat Specialty ",
  },
  {
    value: "05.01",
    title: "Adult ENT",
  },
  {
    value: "05.02",
    title: "Laryngology",
  },
  {
    value: "05.03",
    title: "Neuro - Otology & Otology ",
  },
  {
    value: "05.04",
    title: "Nose, Ear Surgery ",
  },
  {
    value: "05.05",
    title: "Oral & Maxillofacial Surgery ",
  },
  {
    value: "05.06",
    title: "Otolaryngology",
  },
  {
    value: "05.07",
    title: "Pediatrics ENT ",
  },
  {
    value: "05.08",
    title: "Pediatrics Otolaryngology",
  },
  {
    value: "05.09",
    title: "Rhinology ",
  },
  {
    value: "05.10",
    title: "Audiology ",
  },
  {
    value: "06.00",
    title: "Family Medicine Specialty ",
  },
  {
    value: "06.01",
    title: "Family Medicine ",
  },
  {
    value: "06.02",
    title: "Primary Care / Ophthalmology ",
  },
  {
    value: "06.03",
    title: "Primary Care / Pulmonary ",
  },
  {
    value: "06.04",
    title: "Primary Care Preventive Pediatrics",
  },
  {
    value: "06.05",
    title: "Primary Health Care ",
  },
  {
    value: "07.00",
    title: "Forensic Medicine Specialty ",
  },
  {
    value: "08.00",
    title: "Internal Medicine Specialty ",
  },
  {
    value: "08.01",
    title: "Adolescent Medicine ",
  },
  {
    value: "08.02",
    title: "Cardiology ",
  },
  {
    value: "08.03",
    title: "Diabetics Medicine",
  },
  {
    value: "08.04",
    title: "Endocrinology ",
  },
  {
    value: "08.05",
    title: "Gastrology/Gastroenterology",
  },
  {
    value: "08.06",
    title: "Geriatrics ",
  },
  {
    value: "08.07",
    title: "Hematology ",
  },
  {
    value: "08.08",
    title: "Infectious Diseases ",
  },
  {
    value: "08.09",
    title: "Nephrology",
  },
  {
    value: "08.10",
    title: "Nuclear Medicine",
  },
  {
    value: "08.11",
    title: "Oncology ",
  },
  {
    value: "08.12",
    title: "Palliative Medicine ",
  },
  {
    value: "08.13",
    title: "Pulmonology/Chest Medicine ",
  },
  {
    value: "08.14",
    title: "Rheumatology ",
  },
  {
    value: "08.15",
    title: "Sleep Medicine ",
  },
  {
    value: "08.16",
    title: "Sport Medicine",
  },
  {
    value: "08.17",
    title: "Hepatology ",
  },
  {
    value: "08.18",
    title: "Neurology ",
  },
  {
    value: "08.19",
    title: "Radiation Oncology ",
  },
  {
    value: "08.20",
    title: "Diabetes Foot Care ",
  },
  {
    value: "08.21",
    title: "Head & Neck Oncology",
  },
  {
    value: "08.22",
    title: "Hematology - Stem Cell",
  },
  {
    value: "08.23",
    title: "Congenital Heart Disease ",
  },
  {
    value: "08.24",
    title: "Bariatric Medicine ",
  },
  {
    value: "08.25",
    title: "Cardiothoracic",
  },
  {
    value: "08.26",
    title: "General Medicine ",
  },
  {
    value: "09.00",
    title: "Microbiology Specialty ",
  },
  {
    value: "10.00",
    title: "Obstetrics & Gynecology Specialty ",
  },
  {
    value: "10.01",
    title: "Gynecology Oncology ",
  },
  {
    value: "10.02",
    title: "Infertility ",
  },
  {
    value: "10.03",
    title: "IVF",
  },
  {
    value: "10.04",
    title: "Perinatology ",
  },
  {
    value: "10.05",
    title: "Urogynecology ",
  },
  {
    value: "10.06",
    title: "Obstetrics ",
  },
  {
    value: "10.07",
    title: "Reproductive Endocrinology & Infertility ",
  },
  {
    value: "10.08",
    title: "Gynecology ",
  },
  {
    value: "10.09",
    title: "Maternal Fetal Medicine ",
  },
  {
    value: "11.00",
    title: "Ophthalmology Specialty ",
  },
  {
    value: "11.01",
    title: "Comprehensive Ophthalmology ",
  },
  {
    value: "11.02",
    title: "Diseases & Surgery of the Retina ",
  },
  {
    value: "11.03",
    title: "Glaucoma ",
  },
  {
    value: "11.04",
    title: "Neuro - Ophthalmology ",
  },
  {
    value: "11.05",
    title: "Ocular Oncology ",
  },
  {
    value: "11.06",
    title: "Oculoplastic ",
  },
  {
    value: "11.07",
    title: "Ophthalmology ",
  },
  {
    value: "11.08",
    title: "Pediatrics Ophthalmology & Strabismus ",
  },
  {
    value: "11.09",
    title: "Primary Care / Ophthalmology ",
  },
  {
    value: "11.10",
    title: "Uveitis / Medical Retina ",
  },
  {
    value: "11.11",
    title: "Optometric ",
  },
  {
    value: "11.12",
    title: "Anterior Segment ",
  },
  {
    value: "11.13",
    title: "Anaplastology ",
  },
  {
    value: "11.14",
    title: "Macular Dystrophy ",
  },
  {
    value: "11.15",
    title: "Abyplopia ",
  },
  {
    value: "11.16",
    title: "Ophthalmic Photography ",
  },
  {
    value: "12.00",
    title: "Orthopedic Specialty ",
  },
  {
    value: "12.01",
    title: "Oncology Orthopedic ",
  },
  {
    value: "12.02",
    title: "Orthopedic Surgery ",
  },
  {
    value: "12.03",
    title: "Pediatrics Orthopedic ",
  },
  {
    value: "12.04",
    title: "Upper Limp Orthopedic",
  },
  {
    value: "13.00",
    title: "Pathology Specialty ",
  },
  {
    value: "13.01",
    title: "Bone & Soft Tissue Pathology ",
  },
  {
    value: "13.02",
    title: "Dermatopathology ",
  },
  {
    value: "13.03",
    title: "Gast. & Hepat Pathology",
  },
  {
    value: "13.04",
    title: "Histopathology ",
  },
  {
    value: "13.05",
    title: "Lymphoma Pathology",
  },
  {
    value: "13.06",
    title: "Pathology Dermatology ",
  },
  {
    value: "13.07",
    title: "Renal Pathology",
  },
  {
    value: "14.00",
    title: "Pediatric Specialty",
  },
  {
    value: "14.01",
    title: "Fetal Medicine ",
  },
  {
    value: "14.02",
    title: "Neonatal Intensive Care (NICU)",
  },
  {
    value: "14.03",
    title: "Pediatrics Imaging ",
  },
  {
    value: "14.04",
    title: "Pediatrics Endocrinology ",
  },
  {
    value: "14.05",
    title: "Pediatrics Gastroenterology ",
  },
  {
    value: "14.06",
    title: "Pediatrics Genetics ",
  },
  {
    value: "14.07",
    title: "Pediatrics Rheumatology",
  },
  {
    value: "14.08",
    title: "Pediatrics Sleep Medicine ",
  },
  {
    value: "14.09",
    title: "Pediatrics Orthopedic",
  },
  {
    value: "14.10",
    title: "Pediatrics Hematology ",
  },
  {
    value: "14.11",
    title: "Pediatrics Infectious Diseases",
  },
  {
    value: "14.12",
    title: "Pediatrics Intensive Care ",
  },
  {
    value: "14.13",
    title: "Pediatrics Nephrology",
  },
  {
    value: "14.14",
    title: "Pediatrics Pulmonary Diseases ",
  },
  {
    value: "14.15",
    title: "Primary Care Preventive Pediatrics ",
  },
  {
    value: "14.16",
    title: "Pediatric Neurology",
  },
  {
    value: "14.17",
    title: "Fetal Cardiology",
  },
  {
    value: "14.18",
    title: "Neonatology ",
  },
  {
    value: "14.19",
    title: "Pediatric Allergy ",
  },
  {
    value: "14.20",
    title: "Pediatric Cardiology",
  },
  {
    value: "15.00",
    title: "Pediatrics Surgery Specialty",
  },
  {
    value: "15.01",
    title: "Pediatrics Cardiology ",
  },
  {
    value: "15.02",
    title: "Pediatrics Neurosurgery ",
  },
  {
    value: "15.03",
    title: "Pediatrics Oncology ",
  },
  {
    value: "15.04",
    title: "Pediatrics Plastic Surgery ",
  },
  {
    value: "15.05",
    title: "Pediatrics General Surgery ",
  },
  {
    value: "15.06",
    title: "Pediatrics Hematology/Oncology ",
  },
  {
    value: "16.00",
    title: "Physical Medicine & Rehabilitation Specialty ",
  },
  {
    value: "16.01",
    title: "Physical Medicine & Rehabilitation ",
  },
  {
    value: "16.02",
    title: "Occupational Medicine",
  },
  {
    value: "17.00",
    title: "Psychiatry Specialty ",
  },
  {
    value: "17.01",
    title: "Addiction Medicine ",
  },
  {
    value: "17.02",
    title: "Child / Adolescent Psychiatry ",
  },
  {
    value: "17.03",
    title: "Consultation - Liaison Psychiatry ",
  },
  {
    value: "17.04",
    title: "Forensic Psychiatry ",
  },
  {
    value: "17.05",
    title: "Geriatric Psychiatry ",
  },
  {
    value: "17.06",
    title: "Mental Health ",
  },
  {
    value: "17.07",
    title: "Mood Disorders Psychiatry ",
  },
  {
    value: "17.08",
    title: "Psychiatry",
  },
  {
    value: "17.09",
    title: "Rehabilitation Psychiatry ",
  },
  {
    value: "17.10",
    title: "Schizophrenia",
  },
  {
    value: "17.11",
    title: "Pediatric Behavior ",
  },
  {
    value: "17.12",
    title: "Youth Stress Reduction ",
  },
  {
    value: "18.00",
    title: "Radiology Specialty ",
  },
  {
    value: "18.01",
    title: "Body Imaging ",
  },
  {
    value: "18.02",
    title: "Breast Imaging ",
  },
  {
    value: "18.03",
    title: "Cardiac Imaging ",
  },
  {
    value: "18.04",
    title: "Chest Imaging ",
  },
  {
    value: "18.05",
    title: "Diagnostic Neuroradiology",
  },
  {
    value: "18.06",
    title: "Diagnostic Radiology",
  },
  {
    value: "18.07",
    title: "Emergency Radiology ",
  },
  {
    value: "18.08",
    title: "Interventional Neuroradiology ",
  },
  {
    value: "18.09",
    title: "Interventional Radiology ",
  },
  {
    value: "18.10",
    title: "Musculoskeletal Imaging ",
  },
  {
    value: "18.11",
    title: "Pediatrics Imaging ",
  },
  {
    value: "18.12",
    title: "Womens Imaging",
  },
  {
    value: "19.00",
    title: "Surgery Specialty ",
  },
  {
    value: "19.01",
    title: "Arthroplasty Surgery ",
  },
  {
    value: "19.02",
    title: "Bariatric Surgery ",
  },
  {
    value: "19.03",
    title: "Cosmetic Surgery ",
  },
  {
    value: "19.04",
    title: "Craniofacial Surgery ",
  },
  {
    value: "19.05",
    title: "Endocrinology Surgery ",
  },
  {
    value: "19.06",
    title: "Facioplastic ",
  },
  {
    value: "19.07",
    title: "Foot & Ankle Surgery ",
  },
  {
    value: "19.08",
    title: "General Surgery ",
  },
  {
    value: "19.09",
    title: "Hand Surgery ",
  },
  {
    value: "19.10",
    title: "Hepatobiliary & Upper GI Surgery ",
  },
  {
    value: "19.11",
    title: "Neurosurgery (Spinal Surgery) ",
  },
  {
    value: "19.12",
    title: "Neurosurgery / Oncology ",
  },
  {
    value: "19.13",
    title: "Neurosurgery Vascular ",
  },
  {
    value: "19.14",
    title: "Plastic Surgery & Reconstruction ",
  },
  {
    value: "19.15",
    title: "Skull Base Surgery ",
  },
  {
    value: "19.16",
    title: "Spine Surgery",
  },
  {
    value: "19.17",
    title: "Thoracic Surgery/Chest Surgery ",
  },
  {
    value: "19.18",
    title: "Trauma Surgery",
  },
  {
    value: "19.19",
    title: "Vascular Surgery ",
  },
  {
    value: "19.20",
    title: "Colorectal Surgery ",
  },
  {
    value: "19.21",
    title: "Transplant Surgery ",
  },
  {
    value: "19.22",
    title: "Liver Transplant Surgery ",
  },
  {
    value: "19.23",
    title: "Renal and Pancreas Transplant Surgery ",
  },
  {
    value: "19.24",
    title: "Breast Surgery ",
  },
  {
    value: "19.25",
    title: "Cardiothoracic Surgery ",
  },
  {
    value: "19.26",
    title: "Burns",
  },
  {
    value: "20.00",
    title: "Urology Specialty ",
  },
  {
    value: "20.01",
    title: "Gynecology Urology ",
  },
  {
    value: "20.02",
    title: "Laparoscopic Urology ",
  },
  {
    value: "20.03",
    title: "Neuro - Urology ",
  },
  {
    value: "20.04",
    title: "Oncology Urology ",
  },
  {
    value: "20.05",
    title: "Pediatrics Urology ",
  },
  {
    value: "20.06",
    title: "Reconstruction Urology",
  },
  {
    value: "21.00",
    title: "Critical Care ",
  },
  {
    value: "21.01",
    title: "Pediatric Critical Care (PICU) ",
  },
  {
    value: "21.02",
    title: "Intensive Care (ICU) ",
  },
  {
    value: "22.00",
    title: "Dental",
  },
  {
    value: "22.01",
    title: "Pediatric Dental",
  },
  {
    value: "22.02",
    title: "Prosthodontics ",
  },
  {
    value: "22.03",
    title: "Endodontics ",
  },
  {
    value: "22.04",
    title: "Periodontics ",
  },
  {
    value: "22.05",
    title: "Orthodontics",
  },
  {
    value: "22.06",
    title: "Dental Implants ",
  },
  {
    value: "22.07",
    title: "Dental Hygiene ",
  },
  {
    value: "22.08",
    title: "Special Needs Dentistry ",
  },
  {
    value: "23.00",
    title: "Neurophysiology",
  },
  {
    value: "24.00",
    title: "Speech/Speech Language Pathology ",
  },
  {
    value: "25.00",
    title: "Infection Control ",
  },
];
